import { addForecastToRouteQueryString } from '@/helpers/routes';

export default {
  computed: {
    modifiedTo () {
      return addForecastToRouteQueryString(this.to, this.$route);
    },
  },
};
